import { fromJS } from 'immutable';
import { basicSort } from '../../../util/sortUtils';
import {
  tsuVisibleColumns,
  refVisibleColumns,
  volVisibleColumns,
  tsuSort,
  refSort,
  volSort,
} from '../../EditReduxConstant';

export const CLEAR_EDIT_EARTHQUAKE_EVENT = 'CLEAR_EDIT_EARTHQUAKE_EVENT';

export const GET_EDIT_EARTHQUAKE_REQUEST = 'GET_EDIT_EARTHQUAKE_REQUEST';
export const GET_EDIT_EARTHQUAKE_SUCCESS = 'GET_EDIT_EARTHQUAKE_SUCCESS';
export const GET_EDIT_EARTHQUAKE_FAILURE = 'GET_EDIT_EARTHQUAKE_FAILURE';

export const UPDATE_EDIT_EARTHQUAKE_REQUEST = 'UPDATE_EDIT_EARTHQUAKE_REQUEST';
export const UPDATE_EDIT_EARTHQUAKE_SUCCESS = 'UPDATE_EDIT_EARTHQUAKE_SUCCESS';
export const UPDATE_EDIT_EARTHQUAKE_FAILURE = 'UPDATE_EDIT_EARTHQUAKE_FAILURE';

export const CREATE_EDIT_EARTHQUAKE_REQUEST = 'CREATE_EDIT_EARTHQUAKE_REQUEST';
export const CREATE_EDIT_EARTHQUAKE_SUCCESS = 'CREATE_EDIT_EARTHQUAKE_SUCCESS';
export const CREATE_EDIT_EARTHQUAKE_FAILURE = 'CREATE_EDIT_EARTHQUAKE_FAILURE';


export const EDIT_EARTHQUAKE_VOLCANO_REQUEST = 'EDIT_EARTHQUAKE_VOLCANO_REQUEST';
export const EDIT_EARTHQUAKE_VOLCANO_SUCCESS = 'EDIT_EARTHQUAKE_VOLCANO_SUCCESS';
export const EDIT_EARTHQUAKE_VOLCANO_FAILURE = 'EDIT_EARTHQUAKE_VOLCANO_FAILURE';

export const EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST = 'EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST';
export const EDIT_EARTHQUAKE_VOLCANO_SEARCH_SUCCESS = 'EDIT_EARTHQUAKE_VOLCANO_SEARCH_SUCCESS';
export const EDIT_EARTHQUAKE_VOLCANO_SEARCH_FAILURE = 'EDIT_EARTHQUAKE_VOLCANO_SEARCH_FAILURE';

export const EDIT_EARTHQUAKE_TSUNAMI_REQUEST = 'EDIT_EARTHQUAKE_TSUNAMI_REQUEST';
export const EDIT_EARTHQUAKE_TSUNAMI_SUCCESS = 'EDIT_EARTHQUAKE_TSUNAMI_SUCCESS';
export const EDIT_EARTHQUAKE_TSUNAMI_FAILURE = 'EDIT_EARTHQUAKE_TSUNAMI_FAILURE';

export const EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST = 'EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST';
export const EDIT_EARTHQUAKE_TSUNAMI_SEARCH_SUCCESS = 'EDIT_EARTHQUAKE_TSUNAMI_SEARCH_SUCCESS';
export const EDIT_EARTHQUAKE_TSUNAMI_SEARCH_FAILURE = 'EDIT_EARTHQUAKE_TSUNAMI_SEARCH_FAILURE';


export const EDIT_EARTHQUAKE_REFERENCE_REQUEST = 'EDIT_EARTHQUAKE_REFERENCE_REQUEST';
export const EDIT_EARTHQUAKE_REFERENCE_SUCCESS = 'EDIT_EARTHQUAKE_REFERENCE_SUCCESS';
export const EDIT_EARTHQUAKE_REFERENCE_FAILURE = 'EDIT_EARTHQUAKE_REFERENCE_FAILURE';

export const EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST = 'EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST';
export const EDIT_EARTHQUAKE_REFERENCE_SEARCH_SUCCESS = 'EDIT_EARTHQUAKE_REFERENCE_SEARCH_SUCCESS';
export const EDIT_EARTHQUAKE_REFERENCE_SEARCH_FAILURE = 'EDIT_EARTHQUAKE_REFERENCE_SEARCH_FAILURE';

export const EDIT_EARTHQUAKE_REGION_REQUEST = 'EDIT_EARTHQUAKE_REGION_REQUEST';
export const EDIT_EARTHQUAKE_REGION_SUCCESS = 'EDIT_EARTHQUAKE_REGION_SUCCESS';
export const EDIT_EARTHQUAKE_REGION_FAILURE = 'EDIT_EARTHQUAKE_REGION_FAILURE';

export const EDIT_EARTHQUAKE_COUNTRY_REQUEST = 'EDIT_EARTHQUAKE_COUNTRY_REQUEST';
export const EDIT_EARTHQUAKE_COUNTRY_SUCCESS = 'EDIT_EARTHQUAKE_COUNTRY_SUCCESS';
export const EDIT_EARTHQUAKE_COUNTRY_FAILURE = 'EDIT_EARTHQUAKE_COUNTRY_FAILURE';

export const EDIT_EARTHQUAKE_AREA_REQUEST = 'EDIT_EARTHQUAKE_AREA_REQUEST';
export const EDIT_EARTHQUAKE_AREA_SUCCESS = 'EDIT_EARTHQUAKE_AREA_SUCCESS';
export const EDIT_EARTHQUAKE_AREA_FAILURE = 'EDIT_EARTHQUAKE_AREA_FAILURE';

export const EDIT_EARTHQUAKE_LOCATION_REQUEST = 'EDIT_EARTHQUAKE_LOCATION_REQUEST';
export const EDIT_EARTHQUAKE_LOCATION_SUCCESS = 'EDIT_EARTHQUAKE_LOCATION_SUCCESS';
export const EDIT_EARTHQUAKE_LOCATION_FAILURE = 'EDIT_EARTHQUAKE_LOCATION_FAILURE';

export const EDIT_EARTHQUAKE_REFERENCE_SORT = 'EDIT_EARTHQUAKE_REFERENCE_SORT';
export const EDIT_EARTHQUAKE_TSUNAMI_SORT = 'EDIT_EARTHQUAKE_TSUNAMI_SORT';
export const EDIT_EARTHQUAKE_VOLCANO_SORT = 'EDIT_EARTHQUAKE_VOLCANO_SORT';

export const EDIT_EARTHQUAKE_OPEN_CONFIRMATION = 'EDIT_EARTHQUAKE_OPEN_CONFIRMATION';
export const EDIT_EARTHQUAKE_CANCEL_CONFIRMATION = 'EDIT_EARTHQUAKE_CANCEL_CONFIRMATION';

export const EDIT_EARTHQUAKE_REFERENCE_TOGGLE_COLUMN = 'EDIT_EARTHQUAKE_REFERENCE_TOGGLE_COLUMN';
export const EDIT_EARTHQUAKE_TSUNAMI_TOGGLE_COLUMN = 'EDIT_EARTHQUAKE_TSUNAMI_TOGGLE_COLUMN';
export const EDIT_EARTHQUAKE_VOLCANO_TOGGLE_COLUMN = 'EDIT_EARTHQUAKE_VOLCANO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetched: false,
  earthquake: {
    referenceIds: [],
  },
  updating: false,

  volcano: [],
  fetchedVolcano: false,
  volcanoSearchResults: [],
  volcanoSearching: false,

  tsunami: [],
  fetchedTsunami: false,
  tsunamiSearchResults: [],
  tsunamiSearching: false,

  references: [],
  fetchedReferences: false,
  referenceSearchResults: [],
  referenceSearching: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedAreas: false,
  areas: [],
  fetchedLocations: false,
  locations: [],

  tsuSort,
  volSort,
  refSort,

  tsuVisibleColumns,
  volVisibleColumns,
  refVisibleColumns,

  formData: {},
  editConfirmationOpen: false,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const editEarthquakeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_EARTHQUAKE_EVENT:
      return initialState;


    case EDIT_EARTHQUAKE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_EARTHQUAKE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_EARTHQUAKE_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_EARTHQUAKE_REQUEST:
    case UPDATE_EDIT_EARTHQUAKE_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_EARTHQUAKE_SUCCESS:
    case UPDATE_EDIT_EARTHQUAKE_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        earthquake: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_EARTHQUAKE_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        earthquake: action.response,
        updating: false,
      }));
    case CREATE_EDIT_EARTHQUAKE_FAILURE:
    case UPDATE_EDIT_EARTHQUAKE_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_EARTHQUAKE_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));


    case EDIT_EARTHQUAKE_VOLCANO_SORT:
      return state.merge(fromJS({
        volcanoSearchResults: basicSort(action.sort, state.get('volcanoSearchResults')),
        volSort: action.sort,
      }));

    case EDIT_EARTHQUAKE_VOLCANO_REQUEST:
      return state.merge(fromJS({
        fetchedVolcano: false,
      }));
    case EDIT_EARTHQUAKE_VOLCANO_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcano: true,
        volcano: action.response.items,
      }));
    case EDIT_EARTHQUAKE_VOLCANO_FAILURE:
      return state.merge(fromJS({
        fetchedVolcano: true,
      }));

    case EDIT_EARTHQUAKE_VOLCANO_SEARCH_REQUEST:
      return state.merge(fromJS({
        volcanoSearching: true,
      }));
    case EDIT_EARTHQUAKE_VOLCANO_SEARCH_SUCCESS:
      return state.merge(fromJS({
        volcanoSearching: false,
        volcanoSearchResults: basicSort(state.get('volSort'), fromJS(action.response.items)),
      }));
    case EDIT_EARTHQUAKE_VOLCANO_SEARCH_FAILURE:
      return state.merge(fromJS({
        volcanoSearching: false,
      }));


    case EDIT_EARTHQUAKE_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamiSearchResults: basicSort(action.sort, state.get('tsunamiSearchResults')),
        tsuSort: action.sort,
      }));

    case EDIT_EARTHQUAKE_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case EDIT_EARTHQUAKE_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response.items,
      }));
    case EDIT_EARTHQUAKE_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));

    case EDIT_EARTHQUAKE_TSUNAMI_SEARCH_REQUEST:
      return state.merge(fromJS({
        tsunamiSearching: true,
      }));
    case EDIT_EARTHQUAKE_TSUNAMI_SEARCH_SUCCESS:
      return state.merge(fromJS({
        tsunamiSearching: false,
        tsunamiSearchResults: basicSort(state.get('tsuSort'), fromJS(action.response.items)),
      }));
    case EDIT_EARTHQUAKE_TSUNAMI_SEARCH_FAILURE:
      return state.merge(fromJS({
        tsunamiSearching: false,
      }));

    case EDIT_EARTHQUAKE_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReferences: false,
      }));
    case EDIT_EARTHQUAKE_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: action.response.items,
      }));
    case EDIT_EARTHQUAKE_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReferences: true,
      }));


    case EDIT_EARTHQUAKE_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_EARTHQUAKE_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_EARTHQUAKE_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_EARTHQUAKE_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));


    case EDIT_EARTHQUAKE_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case EDIT_EARTHQUAKE_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case EDIT_EARTHQUAKE_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case EDIT_EARTHQUAKE_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EDIT_EARTHQUAKE_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EDIT_EARTHQUAKE_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case EDIT_EARTHQUAKE_AREA_REQUEST:
      return state.merge(fromJS({
        fetchedAreas: false,
      }));
    case EDIT_EARTHQUAKE_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchedAreas: true,
        areas: action.response.items,
      }));
    case EDIT_EARTHQUAKE_AREA_FAILURE:
      return state.merge(fromJS({
        fetchedAreas: true,
        areas: initialState.get('areas'),
      }));

    case EDIT_EARTHQUAKE_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case EDIT_EARTHQUAKE_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case EDIT_EARTHQUAKE_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    case EDIT_EARTHQUAKE_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    case EDIT_EARTHQUAKE_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        tsuVisibleColumns: action.visibleColumns,
      }));

    case EDIT_EARTHQUAKE_VOLCANO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        volVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
